import React, { Component } from 'react';
//import './App.css';


class Search extends Component {
  render() {
    return (
      <div className="App">

      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js